<template>
  <v-autocomplete
    v-bind="$attrs"
    ref="field"
    v-model="localValue"
    :clearable="clearable && !$attrs.readonly && $attrs.readonly !== ''"
    :items="itemList"
    :loading="loading"
    no-filter
    :search-input.sync="match"
    @change="(v) => $emit('change', v)"
    @focus="(e) => e.target.click()"
  >
    <template #selection="data">
      <v-chip
        color="white"
        :selected="data.selected"
        class="chip--select-multi"
        :close="$attrs.multiple"
        @input="removeItem(data.item)"
      >
        <v-avatar>
          <img :src="data.item.photo" />
        </v-avatar>
        {{ data.item.text }}
      </v-chip>
    </template>
    <template #item="data">
      <v-list-tile-avatar>
        <img :src="data.item.photo" />
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title v-html="data.item.text" />
      </v-list-tile-content>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'debounce'
export default {
  name: 'StadiumField',
  props: {
    value: {
      type: [String, Array],
      required: false,
      default: '',
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      match: '',
      itemList: [],
      cacheList: [],
      loading: false,
      init: false,
    }
  },

  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {
    localValue(val, oldVal) {
      if (
        Array.isArray(val) &&
        val.length &&
        (!oldVal || (Array.isArray(oldVal) && !oldVal.length))
      )
        this.init = false
      this.fetch()
    },
    match() {
      this.fetch()
    },
  },
  created() {
    this.fetch = debounce(function () {
      if (this.localValue !== this.$refs.field.lazyValue)
        this.$refs.field.lazyValue = this.localValue

      let params = { set: false }
      if (this.localValue && !Array.isArray(this.localValue)) {
        params._id = this.localValue
      } else if (
        Array.isArray(this.localValue) &&
        this.localValue.length &&
        !this.init
      ) {
        params._id = this.localValue
      } else {
        if (this.match) params.match = this.match
      }
      this.loading = true
      this.$store
        .dispatch('stadiums/fetchSelectList', params)
        .then((list) => {
          this.itemList = []
          list.forEach((item) => {
            this.itemList.push(item)
          })
          if (
            !Array.isArray(this.localValue) &&
            !this.itemList.some((item) => item.value === this.localValue)
          )
            this.localValue = ''
          this.setCache()
        })
        .finally(() => {
          this.loading = false
          this.init = true
        })
    }, 700)
    this.fetch()
  },
  methods: {
    fetch() {},
    setCache() {
      if (Array.isArray(this.localValue)) {
        this.localValue.forEach((v) => {
          const isCached = this.cacheList.some((item) => item.value === v)
          if (!isCached) {
            let item = this.itemList.find((item) => item.value === v)
            if (item) {
              this.cacheList.push(item)
            }
          }
        })
        this.cacheList = this.cacheList.filter((item) =>
          this.localValue.includes(item.value)
        )
        this.cacheList.forEach((cacheItem) => {
          const inList = this.itemList.some(
            (listItem) => listItem.value === cacheItem.value
          )
          if (!inList) this.itemList.push(cacheItem)
        })
      }
    },
    removeItem(item) {
      if (Array.isArray(this.localValue)) {
        const index = this.localValue.indexOf(item.value)
        if (index >= 0) this.localValue.splice(index, 1)
      } else this.localValue = ''
    },
  },
}
</script>
